export default "__VITE_ASSET__DkvRknY0__"